class freeGift {
    constructor() {
        this.freeProducts = window.freeProducts;
        this.reloadPage = false;
        this.init();
    }

    init = () => {
        this.checkFreeGift(this.freeProducts);
    }
    checkFreeGift = () => {
        // debugger;
        if(this.reloadPage && this.freeProducts.length <= 0) {
            window.location.reload();
        }else{
            let product = this.freeProducts.shift();
            console.log("product",product);
            
            let cart = window.cartJson;
            let productExist = cart.items.find((item) => item.product_id == product.id && item.properties['_free_gift']);
            
            
            let cartTotal = cart.total_price;
    
            for(let i=0; i< cart.items.length;i++){
                let item = cart.items[i];
                if(item.properties['_free_gift']){
                    cartTotal = cartTotal - item.line_price;
                }
            }
    
            if (cartTotal >= product.threshold && !productExist) {
                this.addProduct(product.variant_id)
                this.reloadPage = true;
            } else if (cartTotal < product.threshold && productExist) {
                this.reloadPage = true;
                let line = 0;
                this.removeProduct(productExist.key)
                // for(let i=0; i< cart.items.length;i++){
                //     let item = cart.items[i];
                //     if(item.key == productExist.key){
                //         removeProduct(i+1)
                //         break;
                //     }
                // }
            }else{
                this.checkFreeGift();
            }
        }
    }

    addProduct = (id) => {
        let formData = {
            'items': [{
                'id': id,
                'quantity': 1,
                "properties":{
                    "_free_gift": true
                }
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then((data)=>{
                this.checkFreeGift();
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    removeProduct = (id) => {
        let formData = {
                'id': id,
                'quantity': 0
        };

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then((data)=>{
                this.checkFreeGift();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}
if (window?.freeProducts?.length > 0) {
    new freeGift()
}